(function(){
  function initRiskMatrix(){
    var app=document.getElementById('riskApp');
    if(!app||app.getAttribute('data-ra-ready')==='1')return;
    var hostContent=app.closest&&app.closest('.post-content');
    var hostNarrow=app.closest&&app.closest('.container--narrow');
    var hostLayout=app.closest&&app.closest('.blog-layout--single');
    if(hostContent)hostContent.classList.add('ra-host-content');
    if(hostNarrow)hostNarrow.classList.add('ra-host-narrow');
    if(hostLayout)hostLayout.classList.add('ra-host-layout');
    app.setAttribute('data-ra-ready','1');
    app.innerHTML=[
      '<div class="ra-hero">',
      '<div class="ra-hero-inner"><div class="ra-hero-icon"><svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="22" stroke="#CCFF00" stroke-width="3" fill="none"/><path d="M24 12L34 34H14L24 12Z" stroke="#CCFF00" stroke-width="2.5" fill="none" stroke-linejoin="round"/><line x1="24" y1="20" x2="24" y2="28" stroke="#CCFF00" stroke-width="2.5" stroke-linecap="round"/><circle cx="24" cy="31" r="1.5" fill="#CCFF00"/></svg></div><div><h2 class="ra-hero-title">Platform Penilaian Risiko K3</h2><p class="ra-hero-sub">Matriks 6x6 - Analisis Komprehensif</p></div></div>',
      '<div class="ra-badge-row"><span class="ra-badge">ISO 31000</span><span class="ra-badge">ISO 45001</span><span class="ra-badge">HSE Risk Matrix</span></div>',
      '<button class="ra-theme-toggle" id="raThemeToggle" title="Mode Gelap / Terang"><svg class="ra-icon-sun" id="raIconSun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg><svg class="ra-icon-moon" id="raIconMoon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display:none"><path d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z"/></svg></button>',
      '</div>',
      '<div class="ra-stats" id="raStats"><div class="ra-stat"><div class="ra-stat-num" id="raStatTotal">0</div><div class="ra-stat-lbl">Total</div></div><div class="ra-stat ra-st-ext"><div class="ra-stat-num" id="raStatExtreme">0</div><div class="ra-stat-lbl">Extreme</div></div><div class="ra-stat ra-st-hi"><div class="ra-stat-num" id="raStatHigh">0</div><div class="ra-stat-lbl">High</div></div><div class="ra-stat ra-st-md"><div class="ra-stat-num" id="raStatMedium">0</div><div class="ra-stat-lbl">Medium</div></div><div class="ra-stat ra-st-lo"><div class="ra-stat-num" id="raStatLow">0</div><div class="ra-stat-lbl">Low</div></div></div>',
      '<div class="ra-card">',
      '<div class="ra-card-hd"><span class="ra-card-ico">&#x1F4DD;</span><h3 class="ra-card-ttl">Input Penilaian Risiko</h3></div>',
      '<div class="ra-row2"><div class="ra-fg"><label class="ra-label" for="raTask">Aktivitas / Pekerjaan</label><div class="ra-iw"><svg class="ra-ii" viewBox="0 0 20 20" fill="currentColor"><path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/><path fill-rule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5z" clip-rule="evenodd"/></svg><input class="ra-input" type="text" id="raTask" placeholder="Contoh: Hot Work, Lifting, Confined Space"/></div></div><div class="ra-fg"><label class="ra-label" for="raAssessor">Nama Penilai</label><div class="ra-iw"><svg class="ra-ii" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/></svg><input class="ra-input" type="text" id="raAssessor" placeholder="Nama Supervisor / HSE"/></div></div></div>',
      '<div class="ra-fg"><label class="ra-label" for="raLocation">Lokasi Kerja</label><div class="ra-iw"><svg class="ra-ii" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/></svg><input class="ra-input" type="text" id="raLocation" placeholder="Area / Zona Kerja"/></div></div>',
      '<div class="ra-divider"></div><div class="ra-card-hd"><span class="ra-card-ico">&#x26A1;</span><h3 class="ra-card-ttl">Severity - Dampak per Aspek</h3></div><p class="ra-hint">Nilai dampak terburuk yang realistis (worst credible case)</p><div class="ra-sev-grid" id="raSevGrid"></div>',
      '<div class="ra-divider"></div><div class="ra-card-hd"><span class="ra-card-ico">&#x1F4CA;</span><h3 class="ra-card-ttl">Probability - Kemungkinan Terjadi</h3></div><select class="ra-select" id="raProb"></select><div class="ra-desc" id="raProbDesc"></div>',
      '<div class="ra-divider"></div><div class="ra-card-hd"><span class="ra-card-ico">&#x1F6E1;&#xFE0F;</span><h3 class="ra-card-ttl">Kontrol Mitigasi</h3></div><p class="ra-hint">Centang kontrol yang sudah diterapkan</p><div class="ra-ctrl-grid" id="raCtrlGrid"></div>',
      '<div class="ra-divider"></div><div class="ra-card-hd"><span class="ra-card-ico">&#x1F4AC;</span><h3 class="ra-card-ttl">Catatan / Rekomendasi</h3></div><textarea class="ra-textarea" id="raNotes" rows="3" placeholder="Tambahkan catatan, rekomendasi, atau tindakan korektif..."></textarea>',
      '<button class="ra-btn-calc" id="raBtnCalc"><svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18"><path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clip-rule="evenodd"/></svg>Hitung Risiko</button>',
      '</div>',
      '<div class="ra-result" id="raResult"></div>',
      '<div class="ra-card"><div class="ra-card-hd"><span class="ra-card-ico">&#x1F4CA;</span><h3 class="ra-card-ttl">Matriks Risiko 6x6</h3></div><div class="ra-matrix-wrap" id="raMatrix"></div><div class="ra-legend"><span class="ra-chip ra-c-lo">LOW (1-6)</span><span class="ra-chip ra-c-md">MEDIUM (7-12)</span><span class="ra-chip ra-c-hi">HIGH (13-20)</span><span class="ra-chip ra-c-ex">EXTREME (21-36)</span></div></div>',
      '<div class="ra-card"><div class="ra-card-hd"><span class="ra-card-ico">&#x1F4CB;</span><h3 class="ra-card-ttl">Risk Register</h3></div><div class="ra-toolbar"><div class="ra-iw ra-search-w"><svg class="ra-ii" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/></svg><input class="ra-input" type="text" id="raFilter" placeholder="Cari task / assessor..."/></div><div class="ra-toolbar-act"><button class="ra-btn-sm ra-btn-exp" id="raExportCSV" title="Export CSV"><svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15"><path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>CSV</button><button class="ra-btn-sm ra-btn-del" id="raClearHist"><svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15"><path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>Hapus</button></div></div><div class="ra-hist-grid" id="raHistory"></div></div>',
      '<div class="ra-footer">Platform Penilaian Risiko K3 - ISO 31000 / ISO 45001 / Ctrl+Enter untuk hitung cepat</div>'
    ].join('');

    var sevTitles=["Minor","Ringan","Sedang","Serius","Berat","Katastrofik"];
    var sevDesc=[
      "Level 1 (Minor): Gangguan minor, kerusakan kecil, tidak memerlukan perawatan profesional.",
      "Level 2 (Ringan): Luka ringan, mungkin perlu pertolongan pertama (P3K).",
      "Level 3 (Sedang): Cedera membutuhkan perawatan medis profesional (rawat jalan).",
      "Level 4 (Serius): Lost Time Injury (LTI) - pekerja kehilangan waktu kerja.",
      "Level 5 (Berat): Cedera serius / cacat permanen; dampak finansial dan reputasi.",
      "Level 6 (Katastrofik): Fatality atau kerusakan besar (lingkungan/aset/operasional)."
    ];
    var aspects=["Keselamatan","Kesehatan","Lingkungan","Keamanan","Logistik","Sosial","Keuangan"];
    var probTxt=["Sangat Jarang","Jarang","Mungkin","Cukup Sering","Sering","Hampir Pasti"];
    var probDesc=[
      "1 - Sangat Jarang: terjadi sekali >10 tahun.",
      "2 - Jarang: beberapa tahun sekali.",
      "3 - Mungkin: beberapa kali selama umur proyek.",
      "4 - Cukup Sering: setahun sekali.",
      "5 - Sering: beberapa kali per tahun.",
      "6 - Hampir Pasti: sangat mungkin terjadi."
    ];
    var ctrlList=["JSA / Risk Assessment","APD Lengkap","Izin Kerja (Work Permit)","Toolbox Meeting","Barricade / Rambu","Pengawasan Langsung","SOP Tersedia","Pelatihan Khusus","Alat Pemadam","P3K / First Aid Kit","Buddy System","Gas Detector","Fall Protection","LOTO","Emergency Response Plan"];
    var riskAct={LOW:["Monitor rutin","Dokumentasi","Evaluasi berkala"],MEDIUM:["Tindakan korektif 30 hari","Peningkatan kontrol","Review SOP"],HIGH:["Tindakan segera 7 hari","Eskalasi ke manajemen","Tambah APD/kontrol"],EXTREME:["HENTIKAN pekerjaan","Eskalasi Top Management","Re-engineering proses","Investigasi mendalam"]};

    var $=function(id){return app.querySelector('#'+id)};
    var sevGrid=$('raSevGrid'),probSel=$('raProb'),probDescEl=$('raProbDesc'),
        resultDiv=$('raResult'),matrixDiv=$('raMatrix'),histDiv=$('raHistory'),
        filterIn=$('raFilter'),taskIn=$('raTask'),assessorIn=$('raAssessor'),
        locIn=$('raLocation'),notesIn=$('raNotes'),btnCalc=$('raBtnCalc'),
        btnClear=$('raClearHist'),btnCSV=$('raExportCSV'),ctrlGrid=$('raCtrlGrid'),
        tglBtn=$('raThemeToggle'),sunI=$('raIconSun'),moonI=$('raIconMoon');

    function slug(t){return t.toLowerCase().replace(/\s+/g,'_').replace(/[^\w-]/g,'')}
    function esc(s){return s?String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'):''}
    function rl(s){if(s<=6)return{t:'LOW',c:'L'};if(s<=12)return{t:'MEDIUM',c:'M'};if(s<=20)return{t:'HIGH',c:'H'};return{t:'EXTREME',c:'E'}}
    function toast(msg,err){
      var t=document.createElement('div');
      t.className='ra-toast'+(err?' ra-toast-err':'');
      t.textContent=(err?'\u26A0\uFE0F ':'\u2705 ')+msg;
      app.appendChild(t);
      setTimeout(function(){t.style.opacity='0';t.style.transition='opacity .3s';setTimeout(function(){if(t.parentNode)t.parentNode.removeChild(t)},300)},2500);
    }

    var dark=false;try{dark=localStorage.getItem('amar.tools.riskMatrix.v1.dark')==='1'}catch(e){}
    function applyTheme(){
      app.classList.toggle('dark',dark);
      sunI.style.display=dark?'none':'block';
      moonI.style.display=dark?'block':'none';
    }
    tglBtn.addEventListener('click',function(){
      dark=!dark;
      try{localStorage.setItem('amar.tools.riskMatrix.v1.dark',dark?'1':'0')}catch(e){}
      applyTheme();
    });
    applyTheme();

    function buildSev(){
      sevGrid.innerHTML='';
      aspects.forEach(function(asp){
        var id=slug(asp),item=document.createElement('div');
        item.className='ra-sev';
        var lbl=document.createElement('label');
        lbl.className='ra-label';lbl.setAttribute('for','raSev_'+id);lbl.textContent=asp;
        var sel=document.createElement('select');
        sel.className='ra-select';sel.id='raSev_'+id;
        for(var i=0;i<6;i++){
          var o=document.createElement('option');
          o.value=i+1;o.textContent='Level '+(i+1)+' - '+sevTitles[i];
          sel.appendChild(o);
        }
        sel.value='1';
        var g=document.createElement('div'),gb=document.createElement('div'),db=document.createElement('div');
        g.className='ra-gauge';gb.className='ra-gauge-bar';gb.style.width='16.7%';g.appendChild(gb);
        db.className='ra-desc';db.innerHTML='<span class="ra-desc-b">Level 1 - Minor</span><div class="ra-desc-hint">'+sevDesc[0]+'</div>';
        item.appendChild(lbl);item.appendChild(sel);item.appendChild(g);item.appendChild(db);sevGrid.appendChild(item);
        sel.addEventListener('change',function(){
          var v=+this.value,p=this.closest('.ra-sev');
          if(!p)return;
          var bar=p.querySelector('.ra-gauge-bar');
          if(bar)bar.style.width=(v*16.67)+'%';
          var d2=p.querySelector('.ra-desc');
          if(d2)d2.innerHTML='<span class="ra-desc-b">Level '+v+' - '+sevTitles[v-1]+'</span><div class="ra-desc-hint">'+sevDesc[v-1]+'</div>';
        });
      });
    }

    function buildProb(){
      probSel.innerHTML='';
      for(var i=1;i<=6;i++){
        var o=document.createElement('option');
        o.value=i;o.textContent=i+' - '+probTxt[i-1];
        probSel.appendChild(o);
      }
      probSel.value='3';
      function upd(){
        var v=+probSel.value;
        probDescEl.innerHTML='<span class="ra-desc-b">'+v+' - '+probTxt[v-1]+'</span><div class="ra-desc-hint">'+probDesc[v-1]+'</div>';
      }
      probSel.addEventListener('change',upd);upd();
    }

    function buildCtrl(){
      ctrlGrid.innerHTML='';
      ctrlList.forEach(function(c){
        var el=document.createElement('div');
        el.className='ra-ctrl';el.setAttribute('data-ctrl',c);
        el.innerHTML='<div class="ra-chk"><svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg></div><span>'+c+'</span>';
        el.addEventListener('click',function(){this.classList.toggle('on')});
        ctrlGrid.appendChild(el);
      });
    }

    function drawMatrix(sv,pb){
      var h='<table><thead><tr><th style="width:48px">P \\ S</th>';
      for(var s=1;s<=6;s++)h+='<th>S'+s+'</th>';
      h+='</tr></thead><tbody>';
      for(var p=6;p>=1;p--){
        h+='<tr><th>P'+p+'</th>';
        for(s=1;s<=6;s++){
          var sc=s*p,r=rl(sc),sel=(s===sv&&p===pb)?' cSel':'';
          h+='<td class="c'+r.c+sel+'" title="S'+s+' x P'+p+' = '+sc+' ('+r.t+')">'+sc+'</td>';
        }
        h+='</tr>';
      }
      h+='</tbody></table>';
      matrixDiv.innerHTML=h;
    }

    function getChecked(){
      return Array.prototype.slice.call(ctrlGrid.querySelectorAll('.ra-ctrl.on')).map(function(e){return e.getAttribute('data-ctrl')});
    }

    function calc(){
      var ok=true;
      if(!taskIn.value.trim()){taskIn.style.borderColor='#ef4444';ok=false}
      if(!assessorIn.value.trim()){assessorIn.style.borderColor='#ef4444';ok=false}
      if(!ok){
        toast('Isi Aktivitas dan Nama Penilai!',true);
        setTimeout(function(){taskIn.style.borderColor='';assessorIn.style.borderColor=''},2000);
        return;
      }
      var svs=aspects.map(function(a){var s=$('raSev_'+slug(a));return s?+s.value:1});
      var mx=Math.max.apply(null,svs),drv=aspects[svs.indexOf(mx)];
      var pb=+probSel.value,sc=mx*pb,r=rl(sc);
      var pct=Math.round(sc/36*100),ctls=getChecked(),acts=riskAct[r.t]||[];
      var rcls={L:'ra-rl',M:'ra-rm',H:'ra-rh',E:'ra-re'}[r.c];
      resultDiv.style.display='block';
      resultDiv.className='ra-result '+rcls;
      resultDiv.innerHTML='<div class="ra-rd"><div class="ra-rbw"><div class="ra-rscore">'+sc+'</div><div class="ra-rlabel">'+r.t+'</div></div><div class="ra-rmeta"><p><strong>Driver dampak:</strong> '+drv+'</p><p><strong>Severity:</strong> '+mx+' - '+sevTitles[mx-1]+'</p><p><strong>Probability:</strong> '+pb+' - '+probTxt[pb-1]+'</p><p><strong>Kontrol aktif:</strong> '+(ctls.length?ctls.length+' item':'<em>Belum ada</em>')+'</p><div class="ra-gl"><div class="ra-gl-bar" style="width:'+pct+'%"></div></div><p class="ra-hint">'+sevDesc[mx-1]+'</p><p class="ra-hint">'+probDesc[pb-1]+'</p><div class="ra-actions"><span style="font-weight:700;font-size:.78rem;margin-right:.2rem">Rekomendasi:</span>'+acts.map(function(a){return'<span class="ra-atag">&#x2192; '+a+'</span>'}).join('')+'</div></div></div>';
      resultDiv.scrollIntoView({behavior:'smooth',block:'nearest'});
      drawMatrix(mx,pb);
      saveHist(mx,pb,sc,r.t,drv,ctls);
      toast('Risiko: '+r.t+' ('+sc+')');
    }

    var SK='amar.tools.riskMatrix.v1.history',LEGACY_SK='riskH5';
    function getH(){
      try{
        var current=localStorage.getItem(SK);
        if(current)return JSON.parse(current||'[]');
        var legacy=localStorage.getItem(LEGACY_SK);
        if(legacy){
          localStorage.setItem(SK,legacy);
          return JSON.parse(legacy||'[]');
        }
      }catch(e){}
      return[];
    }
    function setH(d){try{localStorage.setItem(SK,JSON.stringify(d))}catch(e){}}
    function saveHist(sv,pb,sc,lv,drv,ct){
      var d=getH();
      d.unshift({time:new Date().toLocaleString('id-ID'),task:taskIn.value.trim()||'(tanpa nama)',assessor:assessorIn.value.trim()||'',location:locIn.value.trim()||'',notes:notesIn.value.trim()||'',sev:sv,prob:pb,score:sc,level:lv,driver:drv,controls:ct||[]});
      setH(d.slice(0,80));renderHist();updateStats();
    }
    function renderHist(){
      var f=filterIn.value.toLowerCase(),d=getH();
      var fd=d.filter(function(i){return i.task.toLowerCase().indexOf(f)>-1||i.assessor.toLowerCase().indexOf(f)>-1||(i.location||'').toLowerCase().indexOf(f)>-1});
      if(!fd.length){
        histDiv.innerHTML='<p class="ra-hint" style="text-align:center;padding:2rem;grid-column:1/-1">Belum ada riwayat penilaian.</p>';
        return;
      }
      histDiv.innerHTML=fd.map(function(i){
        var lc={LOW:'L',MEDIUM:'M',HIGH:'H',EXTREME:'E'}[i.level]||'L';
        var bgc={L:'var(--low-bg)',M:'var(--med-bg)',H:'var(--hi-bg)',E:'var(--ext-bg)'}[lc];
        var txc={L:'var(--low-tx)',M:'var(--med-tx)',H:'var(--hi-tx)',E:'var(--ext-tx)'}[lc];
        return '<div class="ra-hc h'+lc+'"><div class="ra-ht"><span>'+esc(i.task)+'</span><span class="ra-rtag" style="background:'+bgc+';color:'+txc+'">'+i.level+' '+i.score+'</span></div><div class="ra-hm"><div><strong>S'+i.sev+'</strong> x <strong>P'+i.prob+'</strong> - '+esc(i.driver)+'</div>'+(i.location?'<div>&#x1F4CD; '+esc(i.location)+'</div>':'')+(i.controls&&i.controls.length?'<div>&#x1F6E1;&#xFE0F; '+i.controls.length+' kontrol</div>':'')+(i.notes?'<div style="margin-top:3px;font-style:italic">'+esc(i.notes)+'</div>':'')+'<div style="margin-top:3px;opacity:.65">'+i.time+(i.assessor?' - '+esc(i.assessor):'')+'</div></div></div>';
      }).join('');
    }
    function updateStats(){
      var d=getH();
      $('raStatTotal').textContent=d.length;
      $('raStatExtreme').textContent=d.filter(function(x){return x.level==='EXTREME'}).length;
      $('raStatHigh').textContent=d.filter(function(x){return x.level==='HIGH'}).length;
      $('raStatMedium').textContent=d.filter(function(x){return x.level==='MEDIUM'}).length;
      $('raStatLow').textContent=d.filter(function(x){return x.level==='LOW'}).length;
    }
    function clearHist(){
      if(!confirm('Hapus semua riwayat penilaian?'))return;
      try{localStorage.removeItem(SK);localStorage.removeItem(LEGACY_SK)}catch(e){}
      renderHist();updateStats();toast('Riwayat dihapus',true);
    }
    function exportCSV(){
      var d=getH();
      if(!d.length){toast('Tidak ada data',true);return}
      var hdr=['Waktu','Aktivitas','Penilai','Lokasi','Severity','Probability','Score','Level','Driver','Kontrol','Catatan'];
      var csv='\uFEFF'+hdr.join(',')+'\n';
      d.forEach(function(r){
        csv+=[r.time,r.task,r.assessor,r.location||'',r.sev,r.prob,r.score,r.level,r.driver,(r.controls||[]).join('; '),r.notes||''].map(function(c){return'"'+String(c).replace(/"/g,'""')+'"'}).join(',')+'\n';
      });
      var b=new Blob([csv],{type:'text/csv;charset=utf-8;'});
      var a=document.createElement('a');
      a.href=URL.createObjectURL(b);a.download='risk_register_'+new Date().toISOString().slice(0,10)+'.csv';
      document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(a.href);
      toast('CSV berhasil diunduh');
    }

    btnCalc.addEventListener('click',calc);
    filterIn.addEventListener('input',renderHist);
    btnClear.addEventListener('click',clearHist);
    btnCSV.addEventListener('click',exportCSV);
    document.addEventListener('keydown',function(e){if((e.ctrlKey||e.metaKey)&&e.key==='Enter'){e.preventDefault();calc()}});
    buildSev();buildProb();buildCtrl();
    aspects.forEach(function(a){var s=$('raSev_'+slug(a));if(s){var ev;try{ev=new Event('change')}catch(e){ev=document.createEvent('Event');ev.initEvent('change',true,true)}s.dispatchEvent(ev)}});
    drawMatrix(1,3);renderHist();updateStats();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRiskMatrix);
  else initRiskMatrix();
})();
